import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../store/AuthContext";
import Loading from "../components/Loading";

export default function ProtectedRoute({ allowed, children }) {
  const { token, role, ready } = useContext(AuthContext);

  // console.log("🔒 ProtectedRoute Debug:", {
  //   ready,
  //   token: token ? "Token exists" : "No token",
  //   role,
  //   allowed,
  //   currentPath: window.location.pathname,
  //   localStorageToken: localStorage.getItem("token"),
  //   localStorageUser: localStorage.getItem("user"),
  // });

  // ⏳ Wait until auth is fully initialized
  if (!ready) {
    // console.log("🔄 ProtectedRoute: Not ready yet, showing loading");
    return <Loading />;
  }

  // 🔐 Not logged in
  if (!token) {
    // console.log("❌ ProtectedRoute: No token, redirecting to login");
    // console.log("   Stored token in localStorage:", localStorage.getItem("token"));
    return <Navigate to="/" replace />;
  }

  // 🚫 Role not allowed
  if (allowed && !allowed.includes(role)) {
    // console.log(`⛔ ProtectedRoute: Role ${role} not in allowed:`, allowed);
    // redirect based on actual role
    if (role === "teacher") return <Navigate to="/teacher" replace />;
    if (role === "student") return <Navigate to="/student/select-class" replace />;
    if (role === "admin") return <Navigate to="/admin" replace />;

    // fallback
    return <Navigate to="/" replace />;
  }

  // console.log("✅ ProtectedRoute: Access granted");
  return children;
}